import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  "data-follow-stroke": "currentColor",
  cx: "12",
  cy: "12",
  r: "8.8",
  stroke: "currentColor",
  "stroke-width": "1.6",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "data-follow-stroke": "currentColor",
  d: "M9.694 9.95c1.166-4.88 7.729-.42 2.8 2.5a.105.105 0 0 0-.051.089v1.679",
  stroke: "currentColor",
  "stroke-width": "1.6",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  "data-follow-stroke": "currentColor",
  "data-follow-fill": "currentColor",
  cx: "12.424",
  cy: "16.309",
  r: ".5",
  fill: "currentColor",
  stroke: "currentColor",
  "stroke-width": ".6"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }